import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import {useFragment} from 'react-relay'

import SimpleTooltip from '../../../../components/SimpleTooltip'
import getReactji from '../../../../utils/getReactji'
import TeamInsightsCard from './TeamInsightsCard'





const MostUsedEmojisCard = (props) => {
  const {teamInsightsRef} = props
  const insights = useFragment(
    graphql`
      fragment MostUsedEmojisCard_insights on TeamInsights {
        ...TeamInsightsCard_insights
        mostUsedEmojis {
          id
          count
        }
      }
    `,
    teamInsightsRef
  )

  const {mostUsedEmojis} = insights
  if (!mostUsedEmojis || mostUsedEmojis.length === 0) {
    return null
  }

  return (
    React.createElement(TeamInsightsCard, {
      teamInsightsRef: insights,
      title: "Favorite Reactions" ,
      tooltip: "Your team’s most used emoji reactions"     ,}

      , React.createElement('div', { className: "flex flex-row justify-center"  ,}
        , mostUsedEmojis.map((emoji) => {
          const {unicode, shortName} = getReactji(emoji.id)
          return (
            React.createElement('div', { key: emoji.id, className: "flex h-24 w-1/4 flex-col items-center justify-center"     ,}
              , React.createElement(SimpleTooltip, { text: `:${shortName}:`,}
                , React.createElement('div', { className: "text-2xl",}, unicode)
              )
              , React.createElement('div', { className: "p-2 font-semibold" ,}, emoji.count)
            )
          )
        })
      )
    )
  )
}

export default MostUsedEmojisCard
